export enum FieldValueTypes {
    List = 'LST',
    ListUnique = 'LSTUNI',
    ListMultiple = 'LSTMUL',
    Text = 'TXT',
    Number = 'NUM',
    Boolean = 'BOO',
    Date = 'DAT'
}

export function getFieldValueTypeFromString(code: string): FieldValueTypes {
    switch (code) {
        case 'LST':
            return FieldValueTypes.List;
        case 'TXT':
            return FieldValueTypes.Text;
        case 'NUM':
            return FieldValueTypes.Number;
        case 'BOO':
            return FieldValueTypes.Boolean;
        case 'DAT':
            return FieldValueTypes.Date;
        case 'LSTUNI':
            return FieldValueTypes.ListUnique;
        case 'LSTMUL':
            return FieldValueTypes.ListMultiple;
    }
}

export interface PossibleValue {
    Id: number;
    Valeur: string;
}

export type FieldValueValues = string | boolean | number;

export interface FieldValue {
    type: FieldValueTypes;
    value?: FieldValueValues;
    possibleValuesList?: PossibleValue[];
    label?: string;
    code?: string;
}
